import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Swords, Bot, Crown, Shirt } from "lucide-react";

export const Categories = () => {
  const { t } = useTranslation();
  const items = [
    { key: "Action Figures", categoryKey: "Action Figure", label: t("categories.action_figures"), jp: "アクション", icon: Swords,
      span: "md:col-span-6 md:row-span-2", h: "h-80 md:h-full",
      img: "https://static.prod-images.emergentagent.com/jobs/47d8df2c-1cc3-4842-9f62-a771579034aa/images/c05708171b253dc78daedf5291ec5116699e115d7b72817962fa6f4c4105f948.png" },
    { key: "Toys", categoryKey: "Toys", label: t("categories.toys"), jp: "おもちゃ", icon: Bot, span: "md:col-span-6", h: "h-60",
      img: "https://static.prod-images.emergentagent.com/jobs/47d8df2c-1cc3-4842-9f62-a771579034aa/images/d384d66f9bea978190cc620d16f7326d5e8179aa2c0e2aa6ac2da76f8ee8624b.png" },
    { key: "Limited Editions", categoryKey: "Limited Editions", label: t("categories.limited"), jp: "限定版", icon: Crown, span: "md:col-span-3", h: "h-60",
      img: "https://static.prod-images.emergentagent.com/jobs/47d8df2c-1cc3-4842-9f62-a771579034aa/images/b3764587f06586575d456a2d82b78e41d0a544559323b147ad2783c51ff076bd.png" },
    { key: "Merchandise", categoryKey: "Merchandise", label: t("categories.merch"), jp: "グッズ", icon: Shirt, span: "md:col-span-3", h: "h-60",
      img: "https://static.prod-images.emergentagent.com/jobs/47d8df2c-1cc3-4842-9f62-a771579034aa/images/a76d811a4124df30babed34c2f060733842e5c2edb1819e017520bce9c022efa.png" },
  ];

  return (
    <section id="categories" data-testid="categories-section" className="bg-zinc-950 py-24 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between mb-12 gap-6 flex-wrap">
          <div>
            <div className="font-jp text-yellow-400 text-sm tracking-widest mb-3">{t("categories.eyebrow")}</div>
            <h2 className="font-heading text-5xl sm:text-7xl uppercase text-white leading-none">
              {t("categories.title_1")}<br />
              <span className="text-yellow-400">{t("categories.title_2")}</span>
            </h2>
          </div>
          <p className="text-zinc-400 max-w-md text-lg">{t("categories.subtitle")}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 auto-rows-min">
          {items.map((it) => {
            const Icon = it.icon;
            return (
              <Link to={`/shop?category=${encodeURIComponent(it.categoryKey)}`} key={it.key} data-testid={`category-${it.key.replace(/\s+/g, "-").toLowerCase()}`}
                className={`group relative overflow-hidden border-2 border-zinc-800 hover:border-yellow-400 transition-all ${it.span} ${it.h}`}>
                <img src={it.img} alt={it.label}
                  className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-70 group-hover:scale-110 transition-all duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/40 to-transparent" />
                <div className="absolute inset-0 halftone-bg opacity-40" />
                <div className="relative h-full p-6 flex flex-col justify-between">
                  <div className="flex items-start justify-between">
                    <div className="bg-yellow-400 text-black p-2 brutal-shadow-sm">
                      <Icon className="w-5 h-5" strokeWidth={3} />
                    </div>
                    <span className="font-jp text-yellow-400 text-xs tracking-widest">{it.jp}</span>
                  </div>
                  <div>
                    <div className="font-heading text-3xl sm:text-4xl uppercase text-white group-hover:text-yellow-400 transition">
                      {it.label}
                    </div>
                    <div className="text-xs text-zinc-400 uppercase tracking-widest mt-2 group-hover:text-yellow-400 transition">
                      {t("categories.explore")}
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};
